// if component is in reportView( only view!!) and  REFRESHPAYLOAD property is true, then we should run the setComponent
// to send payload to the BE. When we send the setComponent payload we MUST NOT FORGET TO SET REFRESHPAYLOAD PROPERTY
// to false so it will be ran only once.
import { MutableRefObject } from 'react';

import constants from 'constants/constants';

import { useGetComponentKeysWithoutProjectAndContract } from 'hooks/useGetComponentKeysWithoutProjectAndContract';

import { useMutationSetComponent } from 'api/mutations/setComponent.mutation';

import { IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { ReportWidgetRef, Widget } from 'components/Dashboards/Reporting/reporting.types';

interface Props {
    widget: Widget;
    reportWidgetRef: MutableRefObject<ReportWidgetRef | null>;
}

export const useRefreshWidgetPayload = ({ widget, reportWidgetRef }: Props) => {
    const COMPONENT_KEYS_WITHOUT_PROJECT_AND_CONTRACT = useGetComponentKeysWithoutProjectAndContract();
    const { mutateAsync: mutateSetWidgetInReport } = useMutationSetComponent();

    // get widget state from ref connected to widget
    const getWidgetState = () => {
        return JSON.stringify(reportWidgetRef.current?.getWidgetState()) ?? '';
    };

    const getWidgetPayload = () => {
        const payload = JSON.stringify(reportWidgetRef.current?.getWidgetPayload()) ?? '';
        return payload;
    };
    const isWidgetWithoutProjectAndContract = COMPONENT_KEYS_WITHOUT_PROJECT_AND_CONTRACT.includes(
        widget.componentKey as keyof IHashmap,
    );

    // change to more meaningful name
    const setWidgetPayload = async (widget: Widget) => {
        const widgetToBeSaved: Widget = {
            id: widget?.id ?? null,
            componentKey: widget.componentKey,
            contractId: isWidgetWithoutProjectAndContract ? constants.NO_PROJECT_CONTRACT_ID : widget.contractId,
            projectId: isWidgetWithoutProjectAndContract ? constants.NO_PROJECT_CONTRACT_ID : widget.projectId,
            reportId: widget.reportId,
            contractName: widget.contractName,
            lastUpdateDate: widget.lastUpdateDate,
            lastUpdateUser: widget.lastUpdateUser,
            projectName: widget.projectName,
            params: getWidgetState(),
            description: widget.description ?? '',
            showNarrative: widget?.showNarrative ?? false,
            name: widget.name,
            payload: getWidgetPayload(),
            endpoint: reportWidgetRef.current?.getWidgetEndpoint?.(),
            needRefresh: false,
        };
        await mutateSetWidgetInReport(widgetToBeSaved);
    };

    return {
        setWidgetPayload,
    };
};
